module.exports = __webpack_public_path__ + "img/IMG_8618_L_Wood.eaf94ef6.jpg";